'use client';
import React, { createContext, useContext } from 'react';

interface RegionContextType {
  isUs: boolean;
}

export const RegionContext = createContext<RegionContextType | undefined>(
  undefined,
);

export const RegionProvider = ({
  isUs,
  children,
}: {
  isUs: boolean;
  children: React.ReactNode;
}) => {
  return (
    <RegionContext.Provider
      value={{
        isUs,
      }}
    >
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = () => {
  const context = useContext(RegionContext);

  if (!context) {
    throw new Error('useRegion must be used within a RegionProvider');
  }

  return context;
};
